import { create } from 'zustand';
import { getAdapter } from '../lib/vexspark-adapter';

export const useWalletStore = create((set, get) => ({
  address: null,
  isConnected: false,
  balance: '0',

  connect: async () => {
    const adapter = getAdapter();
    try {
      const { address } = await adapter.connect();
      set({ address, isConnected: true });
    } catch (error) {
      console.error('Wallet connect failed:', error);
      throw error;
    }
  },

  disconnect: () => {
    const adapter = getAdapter();
    adapter.disconnect();
    set({ address: null, isConnected: false, balance: '0' });
  },

  /**
   * Sign and submit operations via VexSpark popup.
   * @param {Array} operations — OperationJson[] array
   * @param {{ maxGas?: number, description?: string }} options
   * @returns {string} txHash
   */
  signAndSubmit: async (operations, options = {}) => {
    const adapter = getAdapter();
    if (!adapter.isConnected) {
      throw new Error('Wallet not connected');
    }
    return adapter.signAndSubmit(operations, {
      appName: 'VexForge',
      ...options,
    });
  },

  updateBalance: async () => {},
}));
